import { css } from 'aphrodite';
import * as React from 'react';
import { styleSheet } from './styles';

export interface ScoreDisplayProps {
	score: number;
	size?: 'small' | 'medium' | 'large';
}

/**
 * ScoreDisplay component renders a circular badge with a score (1-10) using color coding:
 * - 1-3: Red (Needs Work)
 * - 4-6: Yellow (Developing)
 * - 7-8: Green (Proficient)
 * - 9-10: Blue (Excellent)
 */
export const ScoreDisplay: React.FC<ScoreDisplayProps> = ({ score, size = 'medium' }) => {
	// Validate score is within range
	const validScore = Math.max(1, Math.min(10, Math.round(score)));

	// Determine color class based on score
	const getColorStyle = () => {
		if (validScore >= 1 && validScore <= 3) {
			return styleSheet.needsWork;
		}
		if (validScore >= 4 && validScore <= 6) {
			return styleSheet.developing;
		}
		if (validScore >= 7 && validScore <= 8) {
			return styleSheet.proficient;
		}
		// validScore >= 9 && validScore <= 10
		return styleSheet.excellent;
	};

	// Determine size style
	const getSizeStyle = () => {
		switch (size) {
			case 'small':
				return styleSheet.containerSmall;
			case 'large':
				return styleSheet.containerLarge;
			case 'medium':
			default:
				return styleSheet.containerMedium;
		}
	};

	return (
		<div className={css(getSizeStyle(), getColorStyle())} aria-label={`Score: ${validScore} out of 10`}>
			{validScore}
		</div>
	);
};
